import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { AdminLayout } from "./components/layout";

// Pages
import LoginPage from "./pages/login";
import EventsPage from "./pages/events";
import UsersPage from "./pages/users";
import ArtistsPage from "./pages/artists";
import VenuesPage from "./pages/venues";
import GenresPage from "./pages/genres";
import ThemesPage from "./pages/themes";
import TranslationsPage from "./pages/translations";
import CuratorPage from "./pages/curator";
import PipelineRunsPage from "./pages/pipeline-runs";
import ReportsPage from "./pages/reports";
import EventResearchPage from "./pages/event-research";
import ArtistResearchPage from "./pages/artist-research";
import SystemPage from "./pages/system";
import SettingsPage from "./pages/settings";

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Public Route wrapper (redirects to dashboard if already logged in)
function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/events" replace />;
  }

  return children;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        {/* Redirect root to events */}
        <Route index element={<Navigate to="/events" replace />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="artists" element={<ArtistsPage />} />
        <Route path="venues" element={<VenuesPage />} />
        <Route path="genres" element={<GenresPage />} />
        <Route path="themes" element={<ThemesPage />} />
        <Route path="pipeline-runs" element={<PipelineRunsPage />} />
        <Route path="curator" element={<CuratorPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="event-research" element={<EventResearchPage />} />
        <Route path="artist-research" element={<ArtistResearchPage />} />
        <Route path="translations" element={<TranslationsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="system" element={<SystemPage />} />
      </Route>

      {/* 404 - Redirect to events */}
      <Route path="*" element={<Navigate to="/events" replace />} />
    </Routes>
  );
}
